export const ScoreSelectors = {
	scoreSlider: 'score-slider',
	scoreInput: 'score-input',
	commentInput: 'comment-input',
	directionsText: 'directions',
	saveButton: 'save-button',
	incorrectScoreAlert: 'incorrect-score-alert',
	incorrectScoreAlertButton: 'incorrect-score-alert-button',
};
